import { showElement } from '../../../../helpers/generic-js/dom.js'
import { loadAppEntity } from '../../../../helpers/app-data-loaders/load-app-entity.js'

export async function showEntityInfo (accountingOrganisationId) {
  const entityInfo = await loadAppEntity(accountingOrganisationId)

  const containerElement = showElement('organisationOverallDetails')
  fillHtml(containerElement, '[d-data="organisationName"]', entityInfo.name)
  fillHtml(containerElement, '[d-data="linkToSyncs"]', `<a href="/app/admin/data-syncs?accountingOrganisationId=${accountingOrganisationId}">Syncs</a>`)
  // fillHtml(containerElement, '[d-data="linkToPnL"]', `<a href="/app/financials/o/${orgId}/pnl" target="_blank">PnL</a>`)
  // fillHtml(containerElement, '[d-data="linkToBS"]', `<a href="/app/financials/o/${orgId}/bs" target="_blank">Balance Sheet</a>`)
}

function fillHtml (containerElement, querySelector, html) {
  const targetElements = containerElement.querySelectorAll(querySelector)
  targetElements.forEach(function (oneElement) {
    oneElement.innerHTML = html
  })
}
